// Module
var code = "<p class=\"text-danger\" translate>error.upload.reason</p> <div ng-repeat=\"(key, errors) in $ctrl.form.$error track by $index\"> <ul> <li ng-repeat=\"e in errors\" ng-if=\"e.$name\"> <span>{{ $ctrl.getLabelFromError(e) }}</span> <b translate>{{ 'error.upload.' + key }}</b> </li> </ul> </div> ";
// Exports
export default code;